exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-pie.js
// module id = 27
// module chunks = 0